import React from 'react';
import { IconTrendUp, IconTrendDown } from './icons';

/**
 * Carte d'indicateur clé (KPI).
 * @param {object} props
 * @param {string} props.label   Libellé de l'indicateur
 * @param {string} props.value   Valeur formatée (string pour garder la maîtrise)
 * @param {string} [props.unit]  Unité affichée en petit
 * @param {React.ComponentType} props.icon
 * @param {{dir:'up'|'down'|'flat', text:string}} [props.trend]
 * @param {number} [props.delay] Décalage d'animation (ms)
 */
export default function StatCard({ label, value, unit, icon: Icon, trend, delay = 0 }) {
  return (
    <article className="kpi reveal" style={{ animationDelay: `${delay}ms` }}>
      <div className="kpi__head">
        <span className="kpi__label">{label}</span>
        <span className="kpi__icon"><Icon /></span>
      </div>
      <div className="kpi__value mono">
        {value}
        {unit && <span className="unit">{unit}</span>}
      </div>
      {trend && (
        <div className={`kpi__trend ${trend.dir}`}>
          {trend.dir === 'up' && <IconTrendUp width={14} height={14} />}
          {trend.dir === 'down' && <IconTrendDown width={14} height={14} />}
          {trend.text}
        </div>
      )}
    </article>
  );
}
